<template>
  <dd-icon-button 
    v-if="isSelected"
    :is-disabled="isDisabled"
    :size="size"
    class="add-remove-button"
    icon="check"
    type="rounded"
    color="dark-grey"
    title="Remove"
    @click="$emit('unchecked', id)"
  />
  <dd-icon-button
    v-else
    :is-disabled="isDisabled"
    :size="size"
    class="add-remove-button"
    icon="plus"
    type="rounded"
    color="grey"
    title="Add"
    @click="$emit('checked', id)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AddRemoveButton',

  props: {
    id: {
      type: Number,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
    },
  },

  emits: ['checked', 'unchecked'],
})
</script>
